import { Configuration, LogLevel } from "@azure/msal-browser";

export const msalConfig: Configuration = {
    auth: {
        authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AAD_TENANT_ID ?? ''}/oauth2/v2.0/authorize`,
        clientId: import.meta.env.VITE_DIGIASSIST_APP_CLIENT_ID ?? 'Not Found',
        redirectUri: globalThis.location.origin,
        navigateToLoginRequestUrl: true
    },
    system: {
        loggerOptions: {
            loggerCallback: (
                level: LogLevel,
                message: string,
                containsPii: boolean
            ): void => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        // Don't log message for info level
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            },
            piiLoggingEnabled: false,
        },
    },
    cache: {
        // sessionStorage is required for bfcache compatibility.
        // With 'memory', acquireTokenSilent falls back to a hidden iframe on every page load
        // (no cached tokens survive a navigation), and an active iframe in the DOM prevents
        // the page from entering the back/forward cache.
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: true,
        secureCookies: true
    }
}
